<script>
    import { sgettext } from '../../../i18n';
    import MaterialRiskRow from './MaterialRiskRow.svelte';
    
    export let name;
    export let worksequences;
    export let roleIndex;
    export let rowSpan;
    export let activityVersionId;

</script>

<table class="table one-px-table-border">
  <colgroup>
    <col style="width: 10%;" />
    <col style="width: 5%;" />
    <col style="width: 8%;" />
    <col style="width: 16%;" />
    <col style="width: 18%;" />
    <col style="width: 18%;" />
    <col style="width: 18%;" />
    <col style="width: 10%;" />
  </colgroup>
  <thead class="thead-light">
    <tr>
      <th>{sgettext('$$SEQUENCE$$')}</th>
      <th>{sgettext('$$STEP$$')}</th>
      <th>{sgettext('$$TYPE$$')}</th>
      <th>{sgettext('$$ELEMENT_1$$')}</th>
      <th>{sgettext('$$ENERGY_MECHANISM$$')}</th>
      <th>{sgettext('$$RISK$$')}</th>
      <th>{sgettext('$$CONTROL$$')}</th>
      <th>{sgettext('$$CONTROL_OWNER$$')}</th>
    </tr>
  </thead>
  <tbody>
    <div />
    {#each worksequences as { name: sequenceName, element_instances, rowSpan: sequenceRowSpan }, sequenceIndex}
      {#if element_instances.length > 0}
        <MaterialRiskRow
          {name}
          {sequenceName}
          {element_instances}
          {rowSpan}
          {sequenceRowSpan}
          {roleIndex}
          {sequenceIndex}
          {activityVersionId}
        />
      {/if}
    {/each}
  </tbody>
</table>

<style>
  table {
    margin: 0px;
    table-layout: fixed;
    width: calc(100% - 0.125rem);
    min-width: 81.25rem;
  }

  th {
    background-color: #f2f2f2;
    font-weight: bold;
    font-size: medium;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
</style>
